import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const invite = sp.get("invite");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      if (invite) {
        try {
          const r = await api.post(`/invites/${invite}/accept`);
          toast.success(`Linked with ${r.data.coach_name}`);
        } catch (er) { toast.error(er?.response?.data?.detail || "Could not accept invite"); }
      } else {
        toast.success("Welcome back");
      }
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <div className="rs-underline mb-4" />
      <h1 className="font-display-heavy text-4xl mb-6">LOG IN</h1>
      <form onSubmit={submit} className="space-y-5 bg-neutral-900 border border-neutral-800 rounded-md p-6">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-base">Email</Label>
          <Input data-testid="login-email-input" id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 bg-neutral-950 border-neutral-700" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password" className="text-base">Password</Label>
          <Input data-testid="login-password-input" id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 bg-neutral-950 border-neutral-700" />
        </div>
        <Button data-testid="login-submit-btn" disabled={busy} className="w-full h-12 bg-red-600 hover:bg-red-700 font-semibold">{busy ? "Signing in…" : "Log in"}</Button>
        <p className="text-sm text-neutral-400 text-center">No account? <Link data-testid="login-goto-signup" to="/register" className="text-red-500 font-semibold hover:underline">Create one</Link></p>
      </form>
    </div>
  );
}
